import React, { useEffect } from 'react';
import AppRoutes from './routes';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { AppInit } from 'AppInit';
import useAuthContext from 'stores/auth-context';
import { getThemeColors, applyCompanyTheme } from 'utils/theme.utils';

const App: React.FC = () => {
  const { accessToken, profile } = useAuthContext();
  const primaryColor = profile?.data.companyProfile?.[0]?.primaryColor;
  const themeColors = getThemeColors(primaryColor);

  useEffect(() => {
    applyCompanyTheme(primaryColor);
  }, [primaryColor]);

  return (
    <ConfigProvider locale={viVN} theme={{ token: { colorPrimary: themeColors.primary } }}>
      <div className='App'>
        {accessToken && <AppInit />}
        <AppRoutes />
      </div>
    </ConfigProvider>
  );
};

export default App;
